// extracted by mini-css-extract-plugin
export default {"layout":"nav-layout_layout__4u6Fi","content":"nav-layout_content__nFIO1"};